import React from 'react'
import './ShareButtons.css'

const ShareButtons = ({ twitterShareLink,
                        facebookShareLink,
                        googlePlusShareLink,
                        downloadClick }) => (
  <div className="share-btn-container">
    <a target='_blank' href={twitterShareLink}>
      <i className={'fa fa-twitter fa-lg m-2 shake-icon'} />
    </a>
    <a target='_blank' href={facebookShareLink}>
      <i className={'fa fa-facebook fa-lg m-2 shake-icon'} />
    </a>
    <a target='_blank' href={googlePlusShareLink}>
      <i className={'fa fa-google-plus fa-lg m-2 shake-icon'} />
    </a>
    <a href={downloadClick} download>
      <i className={'fa fa-download fa-lg m-2 shake-icon'} />
    </a>
  </div>
)

export default ShareButtons



// WEBPACK FOOTER //
// ./src/components/ShareButtons/index.js